import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { DocumentsApiService } from 'features/document-report/api/documents-api.service';
import { queryClient } from 'providers';

import { DocumentQueryKeys } from './query-keys';
const { AddComments } = DocumentsApiService();

export const useCreateComments = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: any) => {
      return AddComments(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: DocumentQueryKeys.all,
        });
      },
    },
  );
};
